module.exports = __webpack_public_path__ + "static/media/man_06.026359ec.png";